import React, {Component} from 'react';

//import {connect} from "react-redux";

class WidgetDefault extends Component {

    UNSAFE_componentWillMount() {
        require('../../../frontend/styles/Widgets.scss');
    }

    render() {
        const {fieldWidth, content: {contentFields}, index} = this.props;
        let w = 100;
        if (fieldWidth && fieldWidth !== w) {
            w = fieldWidth;
        }
        let title = "";
        let body = "";

        for (let x in contentFields) {
            if (contentFields[x].fieldDefinitionKey === "Title") {
                title = contentFields[x].data;
            }
            if (contentFields[x].fieldDefinitionKey === "Body") {
                body = contentFields[x].data;
            }
        }

        return (
            <section className={"widgetDefault widgetDefault-" + index + " w--" + w + " panel.rounded-all p-bc-grey70"}>
                <section className="title-section">
                    <div className="widgetDefault--inner">
                        <h3>{title}</h3>
                    </div>
                </section>
                <section className={"content-section"}>
                    <div className="widgetDefault--inner">
                        <div dangerouslySetInnerHTML={{__html: body}}>
                        </div>
                    </div>
                </section>
            </section>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default WidgetDefault;



// WEBPACK FOOTER //
// ./src/widgets/components/Widgets/WidgetDefault.js